import { Type } from "class-transformer";
import { PlanningBoardDto } from "@/core/features/planning-boards/planning-board.dto";
import { BusinessUnitDto } from "@/core/features/business-units/business-unit.dto";
import { PlanningBoardProjectRowDto } from "@/core/features/planning-boards/planning-board-project-row.dto";
import { ProjectDto } from "@/core/features/projects/project.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { VehicleDto } from "@/core/features/vehicles/vehicle.dto";
import { PlanningBoardTechnicianNearExpirationQualificationDto } from "@/core/features/planning-boards/planning-board-technician-near-expiration-qualification.dto";
import { PlanningBoardVehicleMaintenanceDto } from "@/core/features/planning-boards/planning-board-vehicle-maintenance.dto";
import { PlanningBoardAbsenceAssignmentDto } from "./planning-board-absence-assignment.dto";

export class PlanningBoardStateDto {
  @Type(() => PlanningBoardDto)
  board: PlanningBoardDto | null;

  @Type(() => BusinessUnitDto)
  businessUnit: BusinessUnitDto;

  canReset: boolean;

  @Type(() => PlanningBoardProjectRowDto)
  rows: PlanningBoardProjectRowDto[];

  @Type(() => ProjectDto)
  availableProjects: ProjectDto[];

  @Type(() => UserDto)
  availableTechnicians: UserDto[];

  @Type(() => UserDto)
  vacationTechnicians: UserDto[];

  @Type(() => UserDto)
  sickLeaveTechnicians: UserDto[];

  @Type(() => PlanningBoardAbsenceAssignmentDto)
  absenceAssignments: PlanningBoardAbsenceAssignmentDto[];

  @Type(() => VehicleDto)
  availableVehicles: VehicleDto[];

  @Type(() => UserDto)
  loanedTechnicians: UserDto[];

  @Type(() => VehicleDto)
  loanedVehicles: VehicleDto[];

  @Type(() => UserDto)
  cededTechnicians: UserDto[];

  @Type(() => VehicleDto)
  cededVehicles: VehicleDto[];

  revokedCessionTechnicianIds: string[];

  revokedCessionVehicleIds: string[];

  @Type(() => VehicleDto)
  workshopVehicles: VehicleDto[];

  @Type(() => UserDto)
  trainingTechnicians: UserDto[];

  @Type(() => PlanningBoardTechnicianNearExpirationQualificationDto)
  technicianNearExpirationQualifications: PlanningBoardTechnicianNearExpirationQualificationDto[];

  @Type(() => PlanningBoardVehicleMaintenanceDto)
  vehicleMaintenances: PlanningBoardVehicleMaintenanceDto[];
}
